var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EyeOff_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EyeOff_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "EyeOff_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.305 6.633a10.7 10.7 0 0 0-2.63 2.3 10.7 10.7 0 0 0-1.612 2.719 1 1 0 0 0-.065.348q0 .174.065.348a10.7 10.7 0 0 0 1.612 2.718 10.7 10.7 0 0 0 2.347 2.117A10.52 10.52 0 0 0 12 19q1.632 0 3.127-.454a10.5 10.5 0 0 0 2.157-.932l-7.65-7.65zm14.053 8.395a10.7 10.7 0 0 0 1.58-2.68.97.97 0 0 0 0-.696 10.7 10.7 0 0 0-1.611-2.718 10.7 10.7 0 0 0-2.347-2.117 10.7 10.7 0 0 0-2.852-1.362A10.7 10.7 0 0 0 12.001 5q-.798 0-1.563.108l2.025 2.025z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#796B64",
    fillRule: "evenodd",
    d: "M6.305 6.633a10.7 10.7 0 0 0-2.63 2.3 10.7 10.7 0 0 0-1.612 2.719 1 1 0 0 0-.065.348q0 .174.065.348a10.7 10.7 0 0 0 1.612 2.718 10.7 10.7 0 0 0 2.347 2.117A10.52 10.52 0 0 0 12 19q1.632 0 3.127-.454a10.5 10.5 0 0 0 2.157-.932l-7.65-7.65zm14.053 8.395a10.7 10.7 0 0 0 1.58-2.68.97.97 0 0 0 0-.696 10.7 10.7 0 0 0-1.611-2.718 10.7 10.7 0 0 0-2.347-2.117 10.7 10.7 0 0 0-2.852-1.362A10.7 10.7 0 0 0 12.001 5q-.798 0-1.563.108l2.025 2.025z",
    clipRule: "evenodd",
    mask: "url(#EyeOff_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#796B64",
    d: "M6.571 7.056q-.136.086-.271.176-1.296.867-2.238 2.019-.943 1.15-1.537 2.592l-.462-.191.468.174q-.033.09-.033.174t.033.174l-.468.174.462-.19q.594 1.44 1.537 2.591l-.004-.004q.946 1.156 2.242 2.023 2.587 1.731 5.7 1.731 1.56 0 2.983-.432l-.005.002q1.068-.325 2.06-.89l.247.434-.353.354-7.651-7.651-3.33-3.33.354-.353zm-.194-1.059L9.988 9.61l8.114 8.114-.569.324q-1.089.621-2.254.975l-.005.002q-1.566.475-3.273.475-3.418 0-6.258-1.9-1.418-.95-2.452-2.212l-.003-.004q-1.037-1.266-1.687-2.844l-.004-.009-.003-.008q-.096-.258-.096-.522t.096-.522l.003-.008.004-.009q.65-1.578 1.687-2.844t2.455-2.216q.148-.098.296-.192zm13.592 8.716q.923-1.137 1.508-2.556l.462.191-.469-.174q.065-.174 0-.348l.469-.174-.462.19q-.595-1.44-1.537-2.591-.943-1.152-2.238-2.019-1.295-.866-2.719-1.299h.002Q13.559 5.502 12 5.502q-.763 0-1.493.103l-.07-.495.354-.354 2.024 2.025 7.895 7.895-.353.353zm.427 1.061L12.11 7.487 9.377 4.754l.991-.14q.8-.113 1.633-.113 1.707 0 3.27.475h.003q1.566.476 2.984 1.425 1.419.95 2.455 2.216t1.688 2.844l.003.009.003.008q.194.522 0 1.044l-.003.008-.003.009q-.64 1.553-1.655 2.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M9.32 10.649a3 3 0 0 0 4.03 4.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#796B64",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M3.5 4 20 20.5"
  }))));
};
export default SvgEyeOff;